var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.labelContainer
  }, [_c('div', [_c('p', {
    staticClass: "p1",
    class: _vm.$style.label
  }, [_vm._v(_vm._s(_vm.label) + ":")])])]), !_vm.editMode && !_vm.modelValue.length ? _c('div', {
    class: _vm.$style.valueContainer
  }, [_c('h4', {
    class: _vm.$style.value
  }, [_vm._v(_vm._s('N/A'))])]) : _vm._e(), _vm.editMode ? _c('div', {
    staticClass: "position-relative",
    class: _vm.inputContainerClass
  }, [_c('BaseInputText', {
    staticClass: "mb-3",
    attrs: {
      "disabled": _vm.disabled,
      "name": _vm.name || _vm.label,
      "placeholder": _vm.placeholder,
      "changed": _vm.inputValue !== '' || _vm.isChanged
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addNewValue.apply(null, arguments);
      }
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  }), _c('BaseIcon', {
    class: [_vm.inputValue ? 'color-primary-blue-filter' : 'color-gray-filter', _vm.$style.addIcon],
    attrs: {
      "name": "plus"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.addNewValue.apply(null, arguments);
      }
    }
  })], 1) : _vm._e(), _c('ValidationProvider', {
    ref: "provider",
    attrs: {
      "name": _vm.label
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modelValue,
      expression: "modelValue"
    }],
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.modelValue
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.modelValue = $event.target.value;
      }
    }
  })]), _c('div', {
    class: _vm.$style.multipleItemsList
  }, _vm._l(_vm.modelValue, function (itemValue) {
    return _c('div', {
      key: itemValue,
      class: _vm.$style.individualItem,
      style: {
        'padding-right': _vm.editMode ? '26px' : '10px'
      }
    }, [_c('span', [_vm._v(_vm._s(itemValue))]), _vm.editMode ? _c('i', {
      attrs: {
        "aria-hidden": "true",
        "tabindex": "1"
      },
      on: {
        "click": function click($event) {
          return _vm.removeValue(itemValue);
        }
      }
    }) : _vm._e()]);
  }), 0)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }